import { render, staticRenderFns } from "./MainSlot.vue?vue&type=template&id=0fefcfb0&scoped=true"
import script from "./MainSlot.vue?vue&type=script&lang=js"
export * from "./MainSlot.vue?vue&type=script&lang=js"
import style0 from "./MainSlot.vue?vue&type=style&index=0&id=0fefcfb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fefcfb0",
  null
  
)

export default component.exports